export default {
  state: {
    anchorList: {},
    anchorTypeList: [],
    rotateCarData: [], // 主打车暂定没用过
    rotateCarDataPanoIds: [],
  },
  mutations: {
    setDotsList(state, list) {
      state.anchorList = list;
      const typeList = list.map((o) => {
        return {
          ptid: o.subType,
          materialres: o.materialRes,
          type: o.materialType,
          specId: o.specId,
          anchorName: o.anchorName,
        };
      });
      state.anchorTypeList = typeList;
    },
    setRotateCarData(state, rotateCarData) {
      state.rotateCarData = rotateCarData;
    },
    setRotateCarPanoIds(state, rotateCarDataPanoIds) {
      state.rotateCarDataPanoIds = rotateCarDataPanoIds;
    },
  },
  getters: {
    anchorList: (state) => state.anchorList,
    anchorTypeList: (state) => state.anchorTypeList,
    rotateCarData: (state) => state.rotateCarData,
    rotateCarDataPanoIds: (state) => state.rotateCarDataPanoIds,
  },
  namespaced: true,
};
